import { Y as attributes, a3 as clsx$1, V as bind_props } from "./index.js";
import { clsx } from "clsx";
import { twMerge } from "tailwind-merge";
import { tv } from "tailwind-variants";
const config = {
  title: "connected care"
};
function cn(...inputs) {
  return twMerge(clsx(inputs));
}
const decorate = (title) => {
  return `${title} | ${config?.title}`;
};
const buttonVariants = tv({
  base: "inline-flex items-center justify-center cursor-pointer gap-2 px-6  whitespace-nowrap transition-all outline-none rounded-lg focus-visible:ring-2 focus-visible:ring-offset-2 focus-visible:ring-orange-500 shadow-md disabled:opacity-50 disabled:pointer-events-none aria-disabled:opacity-50 aria-disabled:pointer-events-none [&_svg]:pointer-events-none [&_svg]:shrink-0 [&_svg:not([class*='size-'])]:size-4",
  variants: {
    variant: {
      default: "bg-primary text-primary-foreground hover:bg-primary/90",
      orange: "bg-gradient-to-b from-orange-500 to-orange-700 text-white hover:from-orange-600 hover:to-orange-800 shadow-lg",
      white: "bg-white text-gray-900 shadow-lg",
      destructive: "bg-destructive hover:bg-destructive/90 focus-visible:ring-destructive/20 dark:focus-visible:ring-destructive/40 dark:bg-destructive/60 text-white shadow-xs",
      outline: "bg-background  dark:bg-input/30 dark:border-input dark:hover:bg-input/50 border shadow-xs",
      secondary: "bg-secondary text-secondary-foreground hover:bg-secondary/80 shadow-xs",
      ghost: "hover:bg-accent hover:text-accent-foreground dark:hover:bg-accent/50",
      link: "text-primary underline-offset-4 hover:underline"
    },
    size: {
      default: "h-[56px] min-w-[180px] px-6 py-2 text-lg",
      sm: "h-[40px] min-w-[120px] px-4 py-1 text-sm",
      md: "h-[56px] min-w-[180px] px-6 py-2 text-lg",
      lg: "h-[64px] min-w-[220px] px-8 py-3 text-xl",
      icon: "size-14 min-w-0 p-0",
      "icon-sm": "size-10 min-w-0 p-0",
      "icon-lg": "size-16 min-w-0 p-0"
    }
  },
  defaultVariants: { variant: "default", size: "default" }
});
function Button($$renderer, $$props) {
  $$renderer.component(($$renderer2) => {
    let {
      class: className,
      variant = "default",
      size = "default",
      ref = null,
      href = void 0,
      type = "button",
      disabled,
      children,
      $$slots,
      $$events,
      ...restProps
    } = $$props;
    if (href) {
      $$renderer2.push("<!--[-->");
      $$renderer2.push(`<a${attributes({
        "data-slot": "button",
        class: clsx$1(cn(buttonVariants({ variant, size }), className)),
        href: disabled ? void 0 : href,
        "aria-disabled": disabled,
        role: disabled ? "link" : void 0,
        tabindex: disabled ? -1 : void 0,
        ...restProps
      })}>`);
      children?.($$renderer2);
      $$renderer2.push(`<!----></a>`);
    } else {
      $$renderer2.push("<!--[!-->");
      $$renderer2.push(`<button${attributes({
        "data-slot": "button",
        class: clsx$1(cn(buttonVariants({ variant, size }), className)),
        type,
        disabled,
        ...restProps
      })}>`);
      children?.($$renderer2);
      $$renderer2.push(`<!----></button>`);
    }
    $$renderer2.push(`<!--]-->`);
    bind_props($$props, { ref });
  });
}
export {
  Button as B,
  cn as c,
  decorate as d
};
